import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getSRTimelLinereportslist } from "../../../store/Reports/actions";
import LoadingModel from "../../LoadingModel";
import "../reports.scss";
var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class SRTimelLineReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getSRTimelLinereportslist({
      ...this.props.params,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });
  }

  componentDidUpdate(prevProps) {
    console.log("SRQ_REPORTS_LIST", this.props.SRQ_REPORTS_LIST);
    
    if (this.props.SRQ_REPORTS_LIST && this.props.SRQ_REPORTS_LIST !== prevProps.SRQ_REPORTS_LIST && this.props.SRQ_REPORTS_LIST.length > 0) {
      const csvButton = document.querySelector('.export-excel-btn');
      if (csvButton) {
        csvButton.click();
        this.props.history.push('/srtimelinereport');
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
             {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/srtimelinereport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={
                            this.props.SRQ_REPORTS_LIST?.map((item) => ({
                              Location: item.location_name || "-",
                              "SR No": item.sr_no || "-",
                              "SR Date": item.sr_date || "-",
                              "Item Name": item.item_name || "-",
                              Quantity: item.qty || "-",
                              User: item.user || "-",
                              Department: item.department || "-",
                              "SR HOD Approved By":
                                item.sr_hod_approved_by || "-",
                              "SR HOD Approved Date":
                                item.sr_hod_approved_date || "-",
                              "Service Approved By":
                                item.service_approved_by || "-",
                              "Service Approved Date":
                                item.service_approved_date || "-",
                              "SR to Service Approved Due Days":
                                item.sr_to_service_approved_due_days ?? "-",
                              "SR Item Status": item.sr_item_status || "-",
                              "SI Code": item.si_code || "-",
                              "SI Date": item.si_date || "-",
                              "SI Created By": item.si_created_by || "-",
                              "SI Approved By": item.si_approved_by || "-",
                              "SR to SI Due Days":
                                item.sr_to_si_due_days ?? "-",
                              "SI Item Status": item.si_item_status || "-",
                              "SRFQ No": item.srfq_no || "-",
                              "SRFQ Date": item.srfq_date || "-",
                              "SI to SRFQ Due Days":
                                item.si_to_srfq_due_days ?? "-",
                              "SRFQ Item Status": item.srfq_item_status || "-",
                              "WO No": item.wo_no || "-",
                              "WO Date": item.wo_date || "-",
                              "WO Created By": item.wo_created_by || "-",
                              "SRFQ to WO Due Days":
                                item.srfq_to_wo_due_days ?? "-",
                              "Vendor Name": item.vendor_name || "-",
                              "WO Completion Date":
                                item.wo_completion_date || "-",
                              "WO to Completion Due Days":
                                item.wo_to_completion_due_days ?? "-",
                              "WO Status": item.wo_status || "-",
                            })) || []
                          }
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893",
                            "",
                            "SR TIMELINE REPORT",
                            "",
                          ]}
                          fileName="SR_TIMELINE_REPORT"
                          className="export-excel-btn"
                        />

                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className="ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2" style={{display: 'none'}}>
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        SR TIMELINE REPORT ({" "}
                        {this.props.params.start_date == null ||
                        this.props.params.start_date === ""
                          ? moment(new Date(y, m, 1)).format("DD-MM-YYYY")
                          : moment(this.props.params.start_date).format(
                              "DD-MM-YYYY"
                            )}{" "}
                        TO{" "}
                        {moment(this.props.params.end_date).format(
                          "DD-MM-YYYY"
                        )}{" "}
                        )
                      </h5>
                    </div>

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        className="mb-0 p-0 table-centered table-color-black"
                      >
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="item-name">Location</th>

                            <th>SR No</th>
                            <th>SR Date</th>
                            <th className="item-name">Item Name</th>
                            <th>Qty</th>

                            <th>User</th>
                            <th>Department</th>

                            <th>SR HOD Approved By</th>
                            <th>SR HOD Approved Date</th>
                            <th>Service Approved By</th>
                            <th>Service Approved Date</th>
                            <th>SR → Service Due Days</th>
                            <th>SR Item Status</th>

                            <th className="item-name">SI Code</th>
                            <th>SI Date</th>
                            <th>SI Created By</th>
                            <th>SI Approved By</th>
                            <th>SR → SI Due Days</th>
                            <th>SI Item Status</th>

                            <th>SRFQ No</th>
                            <th>SRFQ Date</th>
                            <th>SI → SRFQ Due Days</th>
                            <th>SRFQ Item Status</th>

                            <th>WO No</th>
                            <th>WO Date</th>
                            <th>WO Created By</th>
                            <th>SRFQ → WO Due Days</th>

                            <th className="item-name">Vendor</th>

                            <th>WO Completion Date</th>
                            <th>WO → Completion Due Days</th>

                            <th>WO Status</th>
                          </tr>
                        </thead>

                        <tbody>
                          {this.props.SRQ_REPORTS_LIST?.length ? (
                            this.props.SRQ_REPORTS_LIST.map(
                              (row, index) => (
                                <tr key={index}>
                                  <td className="item-name">
                                    {row.location_name || "-"}
                                  </td>

                                  <td>{row.sr_no || "-"}</td>
                                  <td>{row.sr_date || "-"}</td>
                                  <td className="item-name">
                                    {row.item_name || "-"}
                                  </td>
                                  <td>{row.qty ?? "-"}</td>

                                  <td>{row.user || "-"}</td>
                                  <td>{row.department || "-"}</td>

                                  <td>{row.sr_hod_approved_by || "-"}</td>
                                  <td>{row.sr_hod_approved_date || "-"}</td>
                                  <td>{row.service_approved_by || "-"}</td>
                                  <td>{row.service_approved_date || "-"}</td>
                                  <td>
                                    {row.sr_to_service_approved_due_days ??
                                      "-"}
                                  </td>
                                  <td>{row.sr_item_status || "-"}</td>

                                  <td className="item-name">
                                    {row.si_code || "-"}
                                  </td>
                                  <td>{row.si_date || "-"}</td>
                                  <td>{row.si_created_by || "-"}</td>
                                  <td>{row.si_approved_by || "-"}</td>
                                  <td>{row.sr_to_si_due_days ?? "-"}</td>
                                  <td>{row.si_item_status || "-"}</td>

                                  <td>{row.srfq_no || "-"}</td>
                                  <td>{row.srfq_date || "-"}</td>
                                  <td>{row.si_to_srfq_due_days ?? "-"}</td>
                                  <td>{row.srfq_item_status || "-"}</td>

                                  <td>{row.wo_no || "-"}</td>
                                  <td>{row.wo_date || "-"}</td>
                                  <td>{row.wo_created_by || "-"}</td>
                                  <td>{row.srfq_to_wo_due_days ?? "-"}</td>

                                  <td className="item-name">
                                    {row.vendor_name || "-"}
                                  </td>

                                  <td>{row.wo_completion_date || "-"}</td>
                                  <td>
                                    {row.wo_to_completion_due_days ?? "-"}
                                  </td>

                                  <td>{row.wo_status || "-"}</td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan={34} className="text-center">
                                No Records Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, SRTimeLine_Doc_report, SRQ_REPORTS_LIST ,loading} =
    state.reports;
  return {
    params,
    reportType,
    SRTimeLine_Doc_report,
    SRQ_REPORTS_LIST,
    loading
  };
};

export default connect(mapStatetoProps, {
  getSRTimelLinereportslist,
})(SRTimelLineReportList);
